import { render, staticRenderFns } from "./NewMediaPost.vue?vue&type=template&id=6f9824d4"
import script from "./NewMediaPost.vue?vue&type=script&lang=js"
export * from "./NewMediaPost.vue?vue&type=script&lang=js"
import style0 from "./NewMediaPost.vue?vue&type=style&index=0&id=6f9824d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports